import PropTypes from 'prop-types';
import React from 'react';
import RightPane from './right-pane';
import { connect } from 'react-redux';

import { closeRightPane } from '../common/actions/right-pane-action-creators';

import {
    activeRightPaneSelector,
    rightPaneTitleSelector,
    rightPaneSubtitleSelector,
    rightPaneVariantSelector
} from '../common/selectors/right-pane-selectors';
import { isEditModeSelector } from '../common/selectors/ui-state-selectors';

export const RightPaneContainer = ( {
    activeRightPane,
    closeRightPane,
    isEditMode,
    subtitle,
    title,
    variant
} ) => {
    return (
        <RightPane
            activePane={activeRightPane}
            automationId="right-pane"
            handleClosePane={closeRightPane}
            isEditMode={isEditMode}
            subtitle={subtitle}
            title={title}
            variant={variant}
        />
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => {
    return {
        activeRightPane: activeRightPaneSelector( state ),
        isEditMode: isEditModeSelector( state ),
        subtitle: rightPaneSubtitleSelector( state ),
        title: rightPaneTitleSelector( state ),
        variant: rightPaneVariantSelector( state )
    };
};

RightPaneContainer.propTypes = {
    activeRightPane: PropTypes.string,
    closeRightPane: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    rightPaneAttributes: PropTypes.object,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired
};

export default connect( mapStateToProps, { closeRightPane } )( RightPaneContainer );
